import { render, staticRenderFns } from "./Exchange_Pending.vue?vue&type=template&id=bd86c580&scoped=true&"
import script from "./Exchange_Pending.vue?vue&type=script&lang=js&"
export * from "./Exchange_Pending.vue?vue&type=script&lang=js&"
import style0 from "./Exchange_Pending.vue?vue&type=style&index=0&id=bd86c580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd86c580",
  null
  
)

export default component.exports